if (!customElements.get('nodus-featured-collections')) {
  class NodusFeaturedCollections extends HTMLElement {
    connectedCallback() {
      this.selectors = {
        track: '.nodus-fc__track',
        nextEl: '.nodus-fc__next',
        prevEl: '.nodus-fc__prev',
      };

      this.sectionId = this.dataset.sectionId;
      this.sectionEl = this.closest(`.section-${this.sectionId}`);
      this.track = this.querySelector(this.selectors.track);

      this.mobileSlides = parseFloat(this.dataset.slidesMobile) || 2;
      this.desktopSlides = parseFloat(this.dataset.slidesDesktop) || 4;
      this.fitDesktopSlides = this.dataset.fitDesktopSlides === 'true';
      this.peek = 0.3;

      this.sliderInstance = false;

      this.initSlider();

      if (Shopify.designMode) {
        this._blockSelect = (e) => {
          if (e.detail.sectionId !== this.sectionId) return;
          const target = e.target;
          const index = Number(target.dataset.index);
          if (!Number.isNaN(index) && this.sliderInstance?.slider) {
            this.sliderInstance.slider.slideTo(index);
          }
        };
        document.addEventListener('shopify:block:select', this._blockSelect);
      }
    }

    disconnectedCallback() {
      if (this._blockSelect) {
        document.removeEventListener('shopify:block:select', this._blockSelect);
        this._blockSelect = null;
      }
      this.destroySlider();
    }

    getSlidesPerView(isDesktop) {
      const base = isDesktop ? this.desktopSlides : this.mobileSlides;
      const peek = isDesktop && this.fitDesktopSlides ? 0 : this.peek;
      return Math.min(20, base + peek);
    }

    initSlider() {
      if (typeof this.sliderInstance === 'object' || !this.track || !this.sectionEl) return;

      this.sliderOptions = {
        slidesPerView: this.getSlidesPerView(false),
        spaceBetween: 12,
        watchOverflow: true,
        navigation: {
          nextEl: this.sectionEl.querySelector(this.selectors.nextEl),
          prevEl: this.sectionEl.querySelector(this.selectors.prevEl),
        },
        loop: false,
        threshold: 2,
        mousewheel: {
          enabled: true,
          forceToAxis: true,
        },
        breakpoints: {
          768: {
            slidesPerView: this.getSlidesPerView(true),
            spaceBetween: 20,
          },
        },
      };

      this.classList.add('swiper');
      this.track.classList.add('swiper-wrapper');

      this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions, [
        FoxTheme.Swiper.Mousewheel,
      ]);
      this.sliderInstance.init();

      const focusableElements = FoxTheme.a11y.getFocusableElements(this);
      for (const element of focusableElements) {
        element.addEventListener('focusin', () => {
          const slide = element.closest('.swiper-slide');
          if (!slide || !this.sliderInstance?.slider) return;
          this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
        });
      }
    }

    destroySlider() {
      if (typeof this.sliderInstance !== 'object') return;
      this.sliderInstance.slider.destroy(true, true);
      this.sliderInstance = false;
      this.classList.remove('swiper');
      if (this.track) {
        this.track.classList.remove('swiper-wrapper');
      }
    }
  }

  customElements.define('nodus-featured-collections', NodusFeaturedCollections);
}
